package org.multiplatform.kotfolio.pages.coroutines

import androidx.compose.runtime.*
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul

@Page("/coroutines/semaphore")
@Composable
fun SemaphorePage() {
    BlogLayout(
        PageProperties(
            "Semaphore parallelism",
            ""),
        BlogProperties("Coroutines", "Semaphore parallelism"))
    {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Semaphore",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Semaphore is a technique by which concurrent processes or operations are managed using an integer value. It takes care of concurrent operations made to the common resources across multiple threads to achieve process synchronization.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Semaphore keeps track of how many permits are available to access a particular resource in according to avoid race conditions. These permits are acquired before accessing and become free when the operation is completed. If a permit can't be acquired (i.e. no permits available), it waits until the permit to access the resource is available. Semaphore serves requests on the basis of FIFO (First in, First out).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Types of semaphore",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Binary semaphore",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Semaphores that are restricted to the values 0 and 1 (locked/unlocked) are called binary semaphores and are used to implement locks.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "At a time, only one process is allowed to access a particular resource which simply acts as a Mutex (A lock is designed to enforce a mutual exclusion concurrency control policy, and with a variety of possible methods there exist multiple unique implementations for different applications. ",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Counting semaphore",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Semaphores that allow an arbitrary resource count are called counting semaphores. It can allow a certain number of processes to access particular resources concurrently.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            KotlinCode(
                code = """
                    private val semaphore = Semaphore(3)
                    
                    semaphore.withPermit {
                    
                    }
                    """.trimIndent()
            )

            //https://github.com/MustafaKoceerr/JustRelax.git
            KotlinCode(
                code = """
                    interface FileDownloadRepository {
                        suspend fun downloadFile(url: String, destinationPath: String): Boolean
                    }
                    
                    internal class FileDownloadRepositoryImpl(
                        private val httpClient: HttpClient,
                        private val dispatchers: DispatcherProvider
                    ) : FileDownloadRepository {

                        override suspend fun downloadFile(url: String, destinationPath: String): Boolean = withContext(dispatchers.io) {
                            try {
                                httpClient.prepareGet(url).execute { httpResponse ->
                                    val channel = httpResponse.bodyAsChannel()

                                    FileSystem.SYSTEM.sink(destinationPath.toPath()).buffer().use { sink ->

                                        val buffer = ByteArray(8 * 1024)

                                        while (!channel.isClosedForRead) {
                                            val bytesRead = channel.readAvailable(buffer)
                                            if (bytesRead < 0) break

                                            sink.write(buffer, 0, bytesRead)
                                        }
                                    }
                                }
                                true
                            } catch (e: Exception) {
                                e.printStackTrace()
                                false
                            }
                        }
                    }
                   
                    """.trimIndent()
            )
        }
    }
}

//https://github.com/MustafaKoceerr/JustRelax.git